import { IncomingBankPayment } from 'src/modules/invoice/models/incomingBankPayment';
import { IncomingBankPaymentImportRequest } from 'src/modules/invoice/models/incomingBankPaymentImportRequest';
import { IncomingBankPaymentPut } from 'src/modules/invoice/models/incomingBankPaymentPut';
import { setPagingParams } from '../functions/createPagingParams';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'IncomingBankPayment';

export const getIncomingBankPayments = (pageIndex, pageSize, sortCol, sortDir, searchString: string, ownerId?: number, status?: number | null) => {
  const endpoint = `${controller}?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}&ownerId=${ownerId || ''}&filter=${
    searchString || ''
  }&status=${status || ''}`;
  return AxiosInstance.get<PagedResult<IncomingBankPayment>>(endpoint);
};

export const getIncomingBankPaymentById = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<IncomingBankPayment>(endpoint);
};

export const importFiles = (data: IncomingBankPaymentImportRequest) => {
  const formData = new FormData();
  data.files?.forEach((x) => {
    formData.append('formFiles', x);
  });
  return AxiosInstance.post(`${controller}/Import`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 360000,
  });
};

export const setIncomingBankPaymentAction = (data: IncomingBankPaymentPut) => {
  return AxiosInstance.put(`${controller}`, data);
};
